import gql from 'graphql-tag';
import { TransactionFragment } from '../fragments/transaction.fragment';

export const CREATE_ONE_CREDITIN = gql`
    mutation(
        $input: CreateOneCreditInInput!
    ) {
        createOneCreditIn (input: $input) {
            ...TransactionInfo
        }
    }
    ${TransactionFragment}
`;